import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class MinimizeViewIcon extends BaseIcon {
    getChildren = () => [
      <path fill={this.getColor()} d="M13.999,14.031 L2.024,14.031 L2.024,12.031 L13.999,12.031 L13.999,14.031 Z"/>
    ]
    getViewBox = () => '0 0 16 16'
}
